"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConstraintsOverviewContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _propTypes2 = require("../shared/propTypes");

var _locales = _interopRequireDefault(require("../i18n/locales"));

var _constraintsOverviewComponent = _interopRequireDefault(require("./constraintsOverviewComponent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ConstraintsOverviewContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ConstraintsOverviewContainer, _Component);

  var _super = _createSuper(ConstraintsOverviewContainer);

  function ConstraintsOverviewContainer() {
    _classCallCheck(this, ConstraintsOverviewContainer);

    return _super.apply(this, arguments);
  }

  _createClass(ConstraintsOverviewContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          constraints = _this$props.constraints,
          options = _this$props.options,
          locale = _this$props.locale,
          allowDataSheets = _this$props.allowDataSheets,
          onChange = _this$props.onChange,
          shouldPaginate = _this$props.shouldPaginate,
          itemsPerPage = _this$props.itemsPerPage,
          getRuleError = _this$props.getRuleError;
      var messages = _locales["default"][locale] || {};
      return (
        /*#__PURE__*/
        _react["default"].createElement(_reactIntl.IntlProvider, {
          locale: locale,
          key: locale,
          messages: messages
        },
        /*#__PURE__*/
        _react["default"].createElement(_constraintsOverviewComponent["default"], {
          options: options,
          constraints: constraints,
          onChange: onChange,
          allowDataSheets: allowDataSheets,
          shouldPaginate: shouldPaginate,
          itemsPerPage: itemsPerPage,
          getRuleError: getRuleError
        }))
      );
    }
  }]);

  return ConstraintsOverviewContainer;
}(_react.Component);

exports.ConstraintsOverviewContainer = ConstraintsOverviewContainer;

_defineProperty(ConstraintsOverviewContainer, "propTypes", {
  constraints: _propTypes["default"].shape({
    dataSheets: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.dataSheetsShape)),
    rules: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.constraintRuleShape))
  }).isRequired,
  options: _propTypes["default"].objectOf(_propTypes["default"].shape(_propTypes2.optionShape)).isRequired,
  locale: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  allowDataSheets: _propTypes["default"].bool,
  shouldPaginate: _propTypes["default"].bool,
  itemsPerPage: _propTypes["default"].number,
  getRuleError: _propTypes["default"].func
});

_defineProperty(ConstraintsOverviewContainer, "defaultProps", {
  options: {},
  locale: 'en',
  allowDataSheets: false,
  getRuleError: function getRuleError() {
    return '';
  }
});

var _default = ConstraintsOverviewContainer;
exports["default"] = _default;